var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p_b_100"},[_c('banner-swiper-slide',{attrs:{"list":_vm.banners}}),_c('checkered-pattern',{attrs:{"list":_vm.patterns}}),_c('innovation-story',{attrs:{"innovationStory":_vm.innovationStory}}),_c('child-module',{attrs:{"childModule":_vm.childModule}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }